import { Box, Typography, SVGIcon, IconButton, KeyboardArrowRightIcon } from "src/components";
import { visualisationGroups } from "src/data";
import { useIsMobile } from "src/hooks";
import { useTripMap, useAuth } from "src/utils";

export default function VisualisationsMenu({ setDrawerState, isTripDetailsTab = true, toggleVisualisationView, mapRef }) {
  const isMobile = useIsMobile();
  const { user } = useAuth();
  const { triggerVisualisation } = useTripMap();

  const handleClick = (slug) => {
    triggerVisualisation(slug);
    if (isMobile) setDrawerState("collapsed");
    toggleVisualisationView();
  };

  const flyToAsync = (map, options) => {
    return new Promise((resolve) => {
      map.flyTo(options);
      map.once('moveend', resolve);
    });
  };

  const delay = (ms) => new Promise(res => setTimeout(res, ms));

  const flyToAlaska = async () => {
    if (isMobile) setDrawerState("collapsed");

    const map = mapRef?.current;
    if (!map) return;

    await delay(4000);

    await flyToAsync(map, {
      center: [-71.05, -51.15],
      zoom: 4.3,
      duration: 4000,
      essential: true
    });

    //10s Pause
    await delay(10000);

    //South America zoomed out
    // map.flyTo({ center: [-73, -16], zoom: 2, duration: 4000 });

    // await delay(4000);

    //Alaska
    map.flyTo({ center: [-144.2, 58.35], zoom: 2.2, duration: 4000 });

    await delay(3000);

    //Globe
    await flyToAsync(map, {
      center: [-107.71, 19.77],
      zoom: 1.3,
      duration: 2000,
    });
  };

  const flyToBolivia = async () => {
    if (isMobile) setDrawerState("collapsed");

    const map = mapRef?.current;
    if (!map) return;

    await delay(4000);

    //Globe
    await flyToAsync(map, {
      center: [-107.71, 19.77],
      zoom: 1.3,
      duration: 2000,
    });

    //10s Pause
    await delay(10000);

    //La Paz
    await flyToAsync(map, {
      center: [-64.7, -16.3],
      zoom: 5,
      duration: 4000,
      essential: true
    });
  };

  const flyToPeru = async () => {
    if (isMobile) setDrawerState("collapsed");

    const map = mapRef?.current;
    if (!map) return;

    await delay(4000);

    //Globe
    await flyToAsync(map, {
      center: [-107.71, 19.77],
      zoom: 1.3,
      duration: 2000,
    });

    //10s Pause
    await delay(10000);

    //Lima
    await flyToAsync(map, {
      center: [-72.5384, -12.4043],
      zoom: 5,
      duration: 4000,
      essential: true
    });
  };

  return (
    <Box className="scrollBox" sx={{ height: '100%', px: 2, pt: 0, pb: isTripDetailsTab ? 0 : 8 }}>
      <Box sx={{width: '100%', mt: 3, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
        <Typography variant="h3">
          Coming Soon
        </Typography>
        <Typography variant="body2" sx={{textAlign: 'center', mt: 1}}>
          We're working on a set of tools for creators to visualise their trips!
        </Typography>
      </Box>
      {user?.role === "Admin" && (<>
        <Box sx={{ mt: 2 }}>
          <IconButton onClick={flyToAlaska}>
            Fly to Alaska
          </IconButton>
        </Box>
        <Box sx={{ mt: 2 }}>
          <IconButton onClick={flyToBolivia}>
            Fly to Bolivia
          </IconButton>
        </Box>
        <Box sx={{ mt: 2 }}>
          <IconButton onClick={flyToPeru}>
            Fly to Peru
          </IconButton>
        </Box>
      </>)}
      {/*{visualisationGroups.map((group, i) => (
        <Box key={i} sx={{ mb: 3 }}>
          <Typography variant="h6" fontWeight={600} sx={{ color: "text.primary" }}>
            {group.title}
          </Typography>

          <Box
            sx={{
              border: "1px solid",
              borderColor: "divider",
              borderRadius: 2,
              overflow: "hidden",
              mt: 2
            }}
          >
            {group.items.map((item, index) => (
              <Box
                key={item.slug}
                onClick={() => handleClick(item.slug)}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  px: 1.5,
                  py: 0.5,
                  cursor: "pointer",
                  backgroundColor: "background.paper",
                  transition: "background 0.2s",
                  "&:hover": {
                    backgroundColor: "#f5f5f5",
                  },
                  borderTop: index === 0 ? "none" : "1px solid",
                  borderColor: "divider",
                }}
              >
                <Box sx={{ mr: 2, display: "flex", alignItems: "center" }}>
                  <SVGIcon icon={item.icon} size={isMobile ? 40 : 30} />
                </Box>

                <Typography variant={isMobile ? "subtitle1" : "body2"} fontWeight={500} sx={{ flexGrow: 1 }}>
                  {item.title}
                </Typography>

                <IconButton size="small" sx={{ color: "text.secondary" }}>
                  <KeyboardArrowRightIcon fontSize={isMobile ? "small" : "inherit"} />
                </IconButton>
              </Box>
            ))}
          </Box>
        </Box>
      ))}*/}
    </Box>
  );
}
